import styled from '@emotion/styled'
import { colors, mediaQueriesByDevice } from 'parameters/index'

export const Title = styled.p`
	font-size: 18px;
	font-weight: bold;
	text-transform: capitalize;
	color: ${colors.white};
	min-height: 29px;
	padding-left: 20px;
	margin-bottom: 10px;
`

export const ListMargins = styled.div`
	margin-right: 37px;

	${mediaQueriesByDevice.tablet} {
		padding: 0;
		margin-right: 0;
		margin-bottom: 16px;

		&:last-of-type {
			margin-bottom: 0;
		}
	}
`

export const FlexGrower = styled.div`
	display: flex;
	flex-grow: 1;
	padding-bottom: 10px;

	${mediaQueriesByDevice.tablet} {
		flex-direction: column;
		overflow: visible;
		margin-bottom: 16px;
		padding-bottom: 0;
	}
`
